module.exports = __webpack_public_path__ + "static/media/u-turn-orbit.a4eb1581.jpg";